export default __webpack_public_path__ + "static/3-a4fc1b23648b9b640078e4adf12cb2c2.webp";